import { AxiosError } from "axios";
import { useCallback, useState } from "react";
import { useSelector } from "react-redux";

import { APPLICATION_TYPE, PRODUCT_DOMAIN } from "@/constants";
import axioInstance from "@/libs/axios";
import { RootState } from "@/store/root-reducer";
import { QuoteData } from "@/types/quote/quote-data";
import { TripDetails } from "@/types/TripDetails";
import logError from "@/utils/logger";

export interface UpdateProps {
  requestdata?: {
    policyType?: string;
    policyPackage?: string;
    area?: string;
    startDate?: string;
    initialQuotePageLoading?: boolean;
    goingOnCruise?: boolean;
  };
  resetTrigger: () => void;
  setIsLoading?: (loading: boolean) => void;
}

type QuoteResponse = {
  data: {
    data: QuoteData;
  };
};

// Custom hook for trip details updating
export default function useUpdateTripDetails({
  // requestdata,
  resetTrigger,
}: UpdateProps) {
  const [data, setData] = useState<null | QuoteData>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<null | AxiosError>(null);

  const { referenceId, version } = useSelector(
    (state: RootState) => state.quote
  );

  const updateTripDetails = useCallback(
    async (bodyData?: TripDetails | null): Promise<QuoteData | null> => {
      // const body = setPatchBody(attributes, requestdata);
      const postBody = {
        data: {
          type: APPLICATION_TYPE,
          channel: "ONLINE",
          version,
          attributes: {
            domain: PRODUCT_DOMAIN,
            tripDetails: bodyData,
          },
        },
      };

      try {
        const response: QuoteResponse = await axioInstance.patch(
          `${process.env.NEXT_PUBLIC_BASE_URL}/quote/${referenceId}/updateTripDetails`,
          postBody
        );
        setData(response.data.data);
        return response.data.data;
      } catch (err) {
        const axiosError = err as AxiosError;
        logError(axiosError, { location: "Quote Update Trip Details" });
        setError(axiosError);
      } finally {
        setLoading(false);
        resetTrigger();
      }
      return null;
    },
    [referenceId, version, resetTrigger]
  );

  return { data, loading, error, updateTripDetails };
}
